import { useState } from 'react';

import { AmountInput, Icon } from '@components/index';
import { getMinPartialPaymentAmountError } from '@features/group-management/helper';
import { FormDataType } from '@types';

import theme from '../../../../../../themes/colors';

interface MinPartialPaymentAmountInputProps {
  formData: FormDataType;
  onAmountChange: (value: string) => void;
}

const MinPartialPaymentAmountInput = ({
  formData,
  onAmountChange
}: MinPartialPaymentAmountInputProps) => {
  const [isTouched, setIsTouched] = useState(false);
  const error = isTouched ? getMinPartialPaymentAmountError(formData) : '';

  return (
    <div className="mt-3 w-full pl-12 md:w-1/2">
      <div className="mb-2 text-sm font-semibold text-cofeeNeutral10">
        Minimum Partial Payment Amount
      </div>
      <AmountInput
        value={formData.minPartialPaymentAmount || ''}
        onAmountChange={onAmountChange}
        handleInputBlur={() => setIsTouched(true)}
        error={!!error}
        errorMessage={error}
        className="!bg-theme"
        allowZero
      />
      <div
        className={`${
          error ? 'mt-4' : 'mt-1'
        } flex items-center gap-1 text-sm text-cofeeNeutral7`}
      >
        <Icon name="alert-circle" stroke={theme.subText} size="16" />
        The minimum amount that payer can pay while doing partial payment.
      </div>
    </div>
  );
};

export default MinPartialPaymentAmountInput;
